import { ErrorState, ID } from 'types';

/**
 * Counts the total number of errors in a given error state.
 * The error state is an object where each key is a line-item ID and the value is an array of column indices with errors.
 *
 * @param errorState - An object where each key is a line-item ID and the value is an array of column indices with errors.
 * @returns The total number of errors in the error state.
 */
export const countStateErrors = (errorState: ErrorState<ID>): number => {
  if (!errorState || !Object.keys(errorState).length) return 0;
  return Object.values(errorState).reduce((total, columns) => total + (columns?.length ?? 0), 0);
};

/**
 * Counts the total number of errors in the provided lotsErrors object.
 * The lotsErrors object is a mapping of lot IDs to their respective error states.
 *
 * @param lotsErrors - An object where each key is a lot ID and the value is an ErrorState object.
 * @returns The total number of errors across all lots.
 */
export const countErrors = (lotsErrors: Record<ID, ErrorState<ID>>): number => {
  if (!lotsErrors || !Object.keys(lotsErrors).length) return 0;
  const errors: ErrorState<ID>[] = Object.values(lotsErrors);

  const lotCounts: number[] = errors.map(countStateErrors);

  return lotCounts.reduce((acc: number, curr: number): number => acc + curr, 0);
};
